import HelpPanel from './help-panel';

export default HelpPanel;
